import { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import { ErrorBoundary } from 'legacy/components/ErrorBoundary/ErrorBoundary'
import SalesforceChat from 'legacy/utils/chat/salesforceChat'

import { BulkSpotQuotePage } from './bulk/BulkSpotQuotePage'
import { SingleSpotQuotePage } from './SingleSpotQuotePage'

type SpotQuotePageProps = {
  match: {
    path: string
  }
}

export default function SpotQuotePage({ match }: SpotQuotePageProps): JSX.Element {
  const { path } = match

  useEffect(function onMount() {
    SalesforceChat.setChatButtonVisibility()

    return function onDismount() {
      SalesforceChat._deferCall(SalesforceChat._cleanupChatAndShowChatButton())
    }
  }, [])

  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${path}/:id/single`} component={SingleSpotQuotePage} exact />
        <Route path={`${path}/:id/bulk`} component={BulkSpotQuotePage} exact />
      </Switch>
    </ErrorBoundary>
  )
}
